<template>
    <div>
        <b-row>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('gear')">
                    <b-input-group>
                        <div class="label-as-input"> {{ this.getLocaleText(form, 'gear_name') }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('plate')">
                    <b-input-group>
                        <div class="label-as-input"> {{  isNotNullValue(form.plate) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('kilometer')">
                    <b-input-group>
                        <div class="label-as-input"> {{  isNotNullValue(form.kilometer) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('maintenance_date')">
                    <b-input-group>
                        <div class="label-as-input"> {{  isNotNullValue(form.maintenance_date) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('status')">
                    <b-input-group>
                        <div class="label-as-input"> {{ this.getLocaleText(form, 'status_name') }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('type')">
                    <b-input-group>
                        <div class="label-as-input"> {{ this.getLocaleText(form, 'type_name') }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    //Service
    import CarService from '@/services/CarService';

    export default {
        props: {
            formId: {
                type: Number
            }
        },
        data() {
            return {
                form: {
                    gear_name: null,
                    plate: null,
                    kilometer: null,
                    maintenance_date: null,
                    status_name: null,
                    type_name: null,
                }
            }
        },
        async created() {
            await this.get(this.formId)
        },
        methods: {
            get(id) {
                this.formLoading = true;
                CarService.get(id)
                                .then((response) => {
                                    this.form = response.data.data;
                                    this.formLoading = false;
                                })
                                .catch((error) => {
                                    this.showErrors(error)
                                });
            }
        }
    }
</script>
